webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Game.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dice__ = __webpack_require__(/*! ./Dice */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(/*! ./Cell */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Player__ = __webpack_require__(/*! ./Player */ 5);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var randomInteger = function randomInteger(min, max) {
  return Math.floor(min + Math.random() * (max + 1 - min));
};

var randDice = function randDice() {
  return randomInteger(1, 5);
};

// TODO: Make an interface

var Cell = function () {
  function Cell(moveDir, image) {
    _classCallCheck(this, Cell);

    this.moveDir = moveDir;
    this.image = image;
  }

  _createClass(Cell, [{
    key: 'onStepOver',
    value: function onStepOver(player) {
      // Does nothing by default
    }
  }, {
    key: 'onStop',
    value: function onStop(player) {
      // Does nothing by default
    }
  }]);

  return Cell;
}();

var BuildingCell = function (_Cell) {
  _inherits(BuildingCell, _Cell);

  function BuildingCell(moveDir, setId, image, text, cost) {
    _classCallCheck(this, BuildingCell);

    var _this = _possibleConstructorReturn(this, (BuildingCell.__proto__ || Object.getPrototypeOf(BuildingCell)).call(this, moveDir, image));

    _this.setId = setId;
    _this.text = text;
    _this.cost = cost;
    _this.houses = 0;
    _this.owner = null;
    return _this;
  }

  _createClass(BuildingCell, [{
    key: 'onStop',
    value: function onStop(player) {
      switch (this.owner) {
        case player:
          break;
        case null:
          this.owner = player;
          player.money -= this.cost;
          player.own.push(this);
          break;
        default:
          this.owner.money += this.cost;
          player.money -= this.cost;
      }
    }
  }]);

  return BuildingCell;
}(Cell);

var DiamondCell = function (_Cell2) {
  _inherits(DiamondCell, _Cell2);

  function DiamondCell(moveDir) {
    _classCallCheck(this, DiamondCell);

    return _possibleConstructorReturn(this, (DiamondCell.__proto__ || Object.getPrototypeOf(DiamondCell)).call(this, moveDir, 'diamond.jpg'));
  }

  return DiamondCell;
}(Cell);

var ChanceCell = function (_Cell3) {
  _inherits(ChanceCell, _Cell3);

  function ChanceCell(moveDir) {
    _classCallCheck(this, ChanceCell);

    return _possibleConstructorReturn(this, (ChanceCell.__proto__ || Object.getPrototypeOf(ChanceCell)).call(this, moveDir, 'chance.png'));
  }

  return ChanceCell;
}(Cell);

var SalaryCell = function (_Cell4) {
  _inherits(SalaryCell, _Cell4);

  function SalaryCell(moveDir) {
    _classCallCheck(this, SalaryCell);

    return _possibleConstructorReturn(this, (SalaryCell.__proto__ || Object.getPrototypeOf(SalaryCell)).call(this, moveDir, 'salary.png'));
  }

  _createClass(SalaryCell, [{
    key: 'onStepOver',
    value: function onStepOver(player) {
      switch (player.level) {
        case 1:
          player.money += 150;
          break;
        case 2:
          player.money += 200;
          break;
        case 3:
          player.money += 250;
          break;
        default:
          throw 'Unknown player level ' + player.level;
      }

      // TODO: Ask if a player would like to upgrade
      if (Math.random() > 0.5 && player.level < 3) {
        player.level += 1;
        player.money -= 50;
      }
    }
  }]);

  return SalaryCell;
}(Cell);

var Player = function Player(id) {
  _classCallCheck(this, Player);

  this.i = 8;
  this.j = 8;
  this.money = 372;
  this.level = 1;
  this.id = id;
  this.own = [];
};

var parkingCell = new Cell('right', 'parking.png');
var jailCell = new Cell('up', 'jail.png');
var policeCell = new Cell('down', 'police.svg');
var salaryCell = new SalaryCell('left');

var cells = new Array(9);
for (var i = 0; i < 9; i++) {
  cells[i] = new Array(9);
}

cells[8][8] = salaryCell;
cells[8][7] = new BuildingCell('left', 1, 'buildings/DogHouse.png', 'Конура', 5);
cells[8][6] = new DiamondCell('left');
cells[8][5] = new BuildingCell('left', 1, 'buildings/TreeHouse.png', 'Дом на дереве', 5);
cells[8][4] = new BuildingCell('left', 2, 'buildings/Igloo.png', 'Иглу', 15);
cells[8][3] = new ChanceCell('left');
cells[8][2] = new BuildingCell('left', 2, 'buildings/Hut.png', 'Палатка', 15);
cells[8][1] = new BuildingCell('left', 2, 'buildings/Shed.png', 'Сарай', 20);

cells[8][0] = jailCell;
cells[7][0] = new BuildingCell('up', 3, 'buildings/Museum.png', 'Музей', 35);
cells[6][0] = new BuildingCell('up', 3, 'buildings/LightHouse.png', 'Маяк', 35);
cells[5][0] = new BuildingCell('up', 3, 'buildings/School.png', 'Школа', 40);
cells[4][0] = new BuildingCell('up', 4, 'buildings/Shop.png', 'Магазин', 55);
cells[3][0] = new DiamondCell('up');
cells[2][0] = new BuildingCell('up', 4, 'buildings/CityHall.png', 'Ратуша', 55);
cells[1][0] = new BuildingCell('up', 4, 'buildings/PostOffice.png', 'Почта', 60);

cells[0][0] = parkingCell;
cells[0][1] = new BuildingCell('right', 5, 'buildings/Embassy.png', 'Посольство', 80);
cells[0][2] = new ChanceCell('right');
cells[0][3] = new BuildingCell('right', 5, 'buildings/Temple.png', 'Храм', 80);
cells[0][4] = new BuildingCell('right', 5, 'buildings/Church.png', 'Церковь', 90);
cells[0][5] = new BuildingCell('right', 6, 'buildings/Hospital.png', 'Больница', 115);
cells[0][6] = new BuildingCell('right', 6, 'buildings/OfficeBuilding.png', 'Офис', 115);
cells[0][7] = new BuildingCell('right', 6, 'buildings/Tower.png', 'Башня', 120);

cells[0][8] = policeCell;
cells[1][8] = new BuildingCell('down', 7, 'buildings/Factory.png', 'Фабрика', 145);
cells[2][8] = new BuildingCell('down', 7, 'buildings/Pyramid.png', 'Пирамида', 145);
cells[3][8] = new DiamondCell('down');
cells[4][8] = new BuildingCell('down', 7, 'buildings/Castle.png', 'Замок', 150);
cells[5][8] = new ChanceCell('down');
cells[6][8] = new BuildingCell('down', 8, 'buildings/Stadium.png', 'Стадион', 170);
cells[7][8] = new BuildingCell('down', 8, 'buildings/Skyscraper.png', 'Небоскрёб', 200);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Game',
  data: function data() {
    return {
      dices: [6, 6],
      cells: cells,
      turn: 0,
      players: [new Player(1), new Player(2), new Player(3), new Player(4)]
    };
  },

  components: {
    DeskCell: __WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* default */],
    Dice: __WEBPACK_IMPORTED_MODULE_0__Dice__["a" /* default */],
    DeskPlayer: __WEBPACK_IMPORTED_MODULE_2__Player__["a" /* default */]
  },
  methods: {
    roll: function roll() {
      this.dices = [randDice(), randDice()];
      this.movePlayer();
    },
    movePlayer: function movePlayer() {
      var _this5 = this;

      var steps = this.dices.reduce(function (acc, val) {
        return acc + val;
      });

      var cell = this.cells[this.currentPlayer.i][this.currentPlayer.j];

      var stepIterval = setInterval(function () {
        switch (cell.moveDir) {
          case 'up':
            _this5.currentPlayer.i -= 1;
            break;
          case 'down':
            _this5.currentPlayer.i += 1;
            break;
          case 'right':
            _this5.currentPlayer.j += 1;
            break;
          case 'left':
            _this5.currentPlayer.j -= 1;
            break;
          default:
            throw 'Unknown moveDir ' + cell.moveDir;
        }

        cell = _this5.cells[_this5.currentPlayer.i][_this5.currentPlayer.j];
        cell.onStepOver(_this5.currentPlayer);

        steps -= 1;

        if (steps <= 0) {
          clearInterval(stepIterval);

          cell.onStop(_this5.currentPlayer);

          var _dices = _slicedToArray(_this5.dices, 2),
              d1 = _dices[0],
              d2 = _dices[1];

          if (d1 !== d2) {
            // TODO: If dices are same for the third time go to jail
            _this5.turn += 1;
          }
        }
      }, 10);
    }
  },
  computed: {
    currentPlayer: function currentPlayer() {
      return this.players[this.turn % this.players.length];
    }
  }
});

/***/ }),
/* 3 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Dice.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dice',
  props: ['value'],
  computed: {
    diceClass: function diceClass() {
      return 'dice-' + this.value;
    }
  }
});

/***/ }),
/* 4 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Cell.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Player__ = __webpack_require__(/*! ./Player */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cell',
  props: ['i', 'j', 'players', 'image', 'text', 'setId', 'cost'],
  components: {
    Player: __WEBPACK_IMPORTED_MODULE_0__Player__["a" /* default */]
  },
  computed: {
    playersIds: function playersIds() {
      var _this = this;

      var ids = [];

      this.players.forEach(function (player) {
        if (_this.i == player.i && _this.j == player.j) {
          ids.push(player.id);
        }
      });

      return ids;
    },
    backgroundStyle: function backgroundStyle() {
      return 'background-image: url(' + this.image + ')';
    },
    buildingCell: function buildingCell() {
      return this.setId;
    }
  }
});

/***/ }),
/* 5 */
/*!*******************************!*\
  !*** ./components/Player.vue ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Player.vue */ 6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b681ea32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b681ea32","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=slm!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Player.vue */ 21);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b681ea32","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Player.vue */ 20)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b681ea32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Player.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Player',
  props: ['id']
});

/***/ }),
/* 7 */
/*!************************!*\
  !*** multi ./index.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/Smelkov/Source/monopoly/index.js */8);


/***/ }),
/* 8 */
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Game__ = __webpack_require__(/*! ./components/Game */ 13);




new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render() {
    var h = arguments[0];

    return h(
      __WEBPACK_IMPORTED_MODULE_1__components_Game__["a" /* default */],
      null,
      []
    );
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/*!*****************************!*\
  !*** ./components/Game.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Game_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Game.vue */ 2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acbd2004_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Game_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-acbd2004","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=slm!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Game.vue */ 23);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-acbd2004","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Game.vue */ 14)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Game_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acbd2004_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Game_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!/Users/Smelkov/node_modules/vue-style-loader!/Users/Smelkov/node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!/Users/Smelkov/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-acbd2004","scoped":false,"hasInlineConfig":true}!/Users/Smelkov/node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Game.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/*!*****************************!*\
  !*** ./components/Dice.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Dice_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dice.vue */ 3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6e2f5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Dice_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7c6e2f5a","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=slm!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dice.vue */ 17);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7c6e2f5a","scoped":false,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Dice.vue */ 16)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Dice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6e2f5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Dice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!/Users/Smelkov/node_modules/vue-style-loader!/Users/Smelkov/node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!/Users/Smelkov/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c6e2f5a","scoped":false,"hasInlineConfig":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Dice.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c6e2f5a","hasScoped":false,"buble":{"transforms":{}}}!/Users/Smelkov/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Dice.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dice",class:_vm.diceClass})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 18 */
/*!*****************************!*\
  !*** ./components/Cell.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/Smelkov/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Cell.vue */ 4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de18ab6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Cell_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6de18ab6","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=slm!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Cell.vue */ 22);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6de18ab6","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Cell.vue */ 19)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_Smelkov_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Cell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de18ab6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Cell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!/Users/Smelkov/node_modules/vue-style-loader!/Users/Smelkov/node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!/Users/Smelkov/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6de18ab6","scoped":false,"hasInlineConfig":true}!/Users/Smelkov/node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Cell.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!/Users/Smelkov/node_modules/vue-style-loader!/Users/Smelkov/node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!/Users/Smelkov/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b681ea32","scoped":false,"hasInlineConfig":true}!/Users/Smelkov/node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Player.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b681ea32","hasScoped":false,"buble":{"transforms":{}}}!/Users/Smelkov/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Player.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"player",class:"id" + _vm.id})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 22 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6de18ab6","hasScoped":false,"buble":{"transforms":{}}}!/Users/Smelkov/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Cell.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buildingCell)?_c('td',[_c('div',{staticClass:"building-card"},[_c('div',{staticClass:"header",class:"-set" + _vm.setId}),_c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}})]),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.cost)+"K$")])])]),_vm._l((_vm.playersIds),function(playerId){return _c('Player',{key:playerId,attrs:{"id":playerId}})})],2):_c('td',{staticClass:"corner image",style:(_vm.backgroundStyle)},_vm._l((_vm.playersIds),function(playerId){return _c('Player',{key:playerId,attrs:{"id":playerId}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 23 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /Users/Smelkov/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acbd2004","hasScoped":false,"buble":{"transforms":{}}}!/Users/Smelkov/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Game.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"desk"},_vm._l((_vm.cells),function(row,i){return _c('tr',[_vm._l((row),function(cell,j){return [(cell)?_c('DeskCell',{staticClass:"cell",attrs:{"cost":cell.cost,"i":i,"image":cell.image,"j":j,"players":_vm.players,"set-id":cell.setId,"text":cell.text}}):(i == 1 && j == 1)?_c('td',{attrs:{"colspan":"7","rowspan":"7"}},[_c('table',[_c('tr',_vm._l((_vm.players),function(player){return _c('td',{key:player.id},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(player == _vm.currentPlayer),expression:"player == currentPlayer"}]},[_vm._v("↓")])])})),_c('tr',_vm._l((_vm.players),function(player){return _c('td',{key:player.id},[_c('DeskPlayer',{attrs:{"id":player.id}})],1)})),_c('tr',_vm._l((_vm.players),function(player){return _c('td',{key:player.id},_vm._l((player.level * 2 - 1),function(n){return _c('span',[_vm._v("★")])}))})),_c('tr',_vm._l((_vm.players),function(player){return _c('td',{key:player.id},[_vm._v(_vm._s(player.money)+"K$")])})),_vm._l(([1,2,3,4,5,6,7,8]),function(setId){return _c('tr',_vm._l((_vm.players),function(player){return _c('td',{key:player.id},_vm._l((player.own.filter(function (b) { return b.setId == setId; })),function(building){return _c('div',[_vm._v(_vm._s(building.text))])}))}))})],2)]):_vm._e()]})],2)})),_c('h1',[_vm._l((_vm.dices),function(dice,i){return _c('Dice',{key:i,attrs:{"value":dice}})}),_vm._v(" "),_c('button',{on:{"click":_vm.roll}},[_vm._v("Role")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[7]);


// WEBPACK FOOTER //
// client.436c7684.js